import React from 'react';

import { UsuarioContextProvider } from './userContext/context';
import { SystemContextProvider } from './systemContext/context';

const GlobalContext: React.FC = ({ children }) => {
  return (
    <>
      <UsuarioContextProvider>
        <SystemContextProvider>
          {children}
        </SystemContextProvider>
      </UsuarioContextProvider>
    </>
  );
};

export default GlobalContext;